var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageCropCircleMask = function SvgImageCropCircleMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 335 335",
    style: {
      enableBackground: "new 0 0 335 335"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "image-crop-circle-mask_svg__a",
    d: "M0 0h335v335H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "image-crop-circle-mask_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-crop-circle-mask_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#image-crop-circle-mask_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.5 0H0v335h335V0H167.5zm0 0C260 0 335 75 335 167.5S260 335 167.5 335 0 260 0 167.5 75 0 167.5 0z",
    style: {
      opacity: 0.6,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#061b09",
      enableBackground: "new"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 167.5,
    r: 166.5,
    style: {
      fill: "none",
      stroke: "#e7ece9",
      strokeWidth: 2
    }
  })));
};
export default SvgImageCropCircleMask;